import { type FC } from 'react';

import { useTranslation } from 'react-i18next';

import { getCurrency } from 'use-cases/getPriceAndCurrency';

import defaultRadio from '../assets/defaultRadio.svg';
import rocket from '../assets/rocket.svg';

interface CreditsBlockProps {
  item: any;
  selectedPlan: any;
  planWithDetails: string | null;
  onPlanClick: (item: any) => void;
  isBestValue?: boolean;
  children?: React.ReactNode;
}

const CreditsBlock: FC<CreditsBlockProps> = ({
  item,
  selectedPlan,
  planWithDetails,
  onPlanClick,
  isBestValue = false,
  children
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`rounded-xl border ${
        selectedPlan?.id === item.id ? 'border-[#5F30E2] border-2' : 'border-[rgba(0, 0, 0, 0.15)]'
      }`}
    >
      <div
        onClick={() => onPlanClick(item)}
        className={`relative p-4 tablet:py-5 tablet:px-6 cursor-pointer flex justify-between`}
      >
        {isBestValue && (
          <div className='absolute top-[18px] right-[89px] bg-[#5f30e214] py-1 px-[6px] gap-1 border rounded-lg hidden tablet:flex'>
            <img
              src={rocket}
              alt='rocket'
            />
            <p className='text-[#5F30E2] text-[13px] font-bold leading-[18px]'>{t('upsale_modal.best_value')}</p>
          </div>
        )}
        <div className='flex gap-2 items-center'>
          <img
            src={defaultRadio}
            alt='defaultRadio'
          />
          <div
            className={`text-[#000000de] text-[16px] leading-[22px] ${selectedPlan?.id === item?.id && 'font-bold'}`}
          >
            {item.credits} {t('upsale_modal.credits')}
          </div>
        </div>
        <div className={`text-[#000000de] text-[16px] leading-[22px] ${selectedPlan?.id === item?.id && 'font-bold'}`}>
          {getCurrency(item?.price?.currency)}
          {item?.price?.price && item?.price?.price / 100}
        </div>
      </div>
      {planWithDetails === item.id && children}
    </div>
  );
};

export default CreditsBlock;
